module.exports = __webpack_public_path__ + "img/illustrations-gift.9ce54e42.png";